import { useTextToolbarModel } from './text-toolbar.model'
import type { ITextToolbar } from './text-toolbar.types'
import { TextToolbarView } from './text-toolbar.view'

export const TextToolbar = ({ align }: ITextToolbar) => {
  const textToolbarModel = useTextToolbarModel()
  return <TextToolbarView {...textToolbarModel} align={align} />
}
